// Taken from https://github.com/moment/moment/tree/master/src/locale

export const withTimeIncludingSeconds = {
  'af': 'D MMMM YYYY hh:mm:ss A', // Afrikaans
  'ar': 'D MMMM YYYY hh:mm:ss A', // Arabic
  'az': 'D MMMM YYYY hh:mm:ss A', // Azerbaijani
  'be': 'D MMMM YYYY г., hh:mm:ss A', // Belarusian
  'bg': 'D MMMM YYYY hh:mm:ss A', // Bulgarian
  'bn': 'D MMMM YYYY, A h:mm:ss সময়', // Bengali
  'bo': 'D MMMM YYYY, A h:mm:ss', // Tibetan
  'br': 'D [a viz] MMMM YYYY h[e]mm[e]ss A', // Breton
  'bs': 'D. MMMM YYYY hh:mm:ss A', // Bosnian
  'ca': '[el] D MMMM [de] YYYY [a les] hh:mm:ss A', // Catalan
  'cs': 'dddd D. MMMM YYYY hh:mm:ss A', // Czech
  'cv': 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], hh:mm:ss A', // Chuvash
  'cy': 'D MMMM YYYY hh:mm:ss A', // Welsh
  'da': 'D. MMMM YYYY hh:mm:ss A', // Danish
  'de': 'D. MMMM YYYY hh:mm:ss A', // German
  'dv': 'D MMMM YYYY hh:mm:ss A', // Maldivian
  'el': 'D MMMM YYYY hh:mm:ss A', // Greek
  'en': 'MMMM D, YYYY hh:mm:ss A', // English
  'eo': 'D[-a de] MMMM, YYYY hh:mm:ss A', // Esperanto
  'es': 'D [de] MMMM [de] YYYY hh:mm:ss A', // Spanish
  'et': 'D. MMMM YYYY hh:mm:ss A', // Estonian
  'eu': 'YYYY[ko] MMMM[ren] D[a] hh:mm:ss A', // Basque
  'fa': 'D MMMM YYYY hh:mm:ss A', // Persian
  'fi': 'Do MMMM[ta] YYYY, [klo] hh.mm.ss A', // Finnish
  'fo': 'D MMMM YYYY hh:mm:ss A', // Faroese
  'fr': 'D MMMM YYYY hh:mm:ss A', // French
  'fy': 'D MMMM YYYY hh:mm:ss A', // Frisian
  'gd': 'D MMMM YYYY hh:mm:ss A', // Scottish Gaelic
  'gl': 'D [de] MMMM [de] YYYY hh:mm:ss A', // Galician
  'he': 'D [ב]MMMM YYYY hh:mm:ss A', // Hebrew
  'hi': 'D MMMM YYYY, A h:mm:ss बजे', // Hindi
  'hr': 'D. MMMM YYYY h:mm:ss A', // Croatian
  'hu': 'YYYY. MMMM D. h:mm:ss A', // Hungarian
  'id': 'D MMMM YYYY [pukul] hh.mm.ss A', // Indonesian
  'is': 'D. MMMM YYYY [kl.] h:mm:ss A', // Icelandic
  'it': 'D MMMM YYYY hh:mm:ss A', // Italian
  'ja': 'YYYY年M月D日 hh:mm:ss A', // Japanese
  'jv': 'D MMMM YYYY [pukul] hh.mm.ss A', // Javanese
  'ka': 'D MMMM YYYY h:mm:ss A', // Georgian
  'kk': 'D MMMM YYYY hh:mm:ss A', // Kazakh
  'km': 'D MMMM YYYY hh:mm:ss A', // Cambodian
  'kn': 'D MMMM YYYY, A h:mm:ss', // Kannada
  'ko': 'YYYY년 MMMM D일 A h:mm:ss', // Korean
  'ky': 'D MMMM YYYY hh:mm:ss A', // Kyrgyz
  'lb': 'D. MMMM YYYY h:mm:ss A [Auer]', // Luxembourgish
  'lo': 'D MMMM YYYY hh:mm:ss A', // Lao
  'lt': 'YYYY [m.] MMMM D [d.], hh:mm:ss A [val.]', // Lithuanian
  'lv': 'YYYY. [gada] D. MMMM, hh:mm:ss A', // Latvian
  'me': 'D. MMMM YYYY h:mm:ss A', // Montenegrin
  'mi': 'D MMMM YYYY [i] hh:mm:ss A', // Maori
  'mk': 'D MMMM YYYY h:mm:ss A', // Macedonian
  'ml': 'D MMMM YYYY h:mm:ss A', // Malayalam
  'mr': 'D MMMM YYYY, A h:mm वाजता', // Marathi
  'ms': 'D MMMM YYYY [pukul] hh.mm.ss A', // Malay
  'my': 'D MMMM YYYY hh:mm:ss A', // Burmese
  'nb': 'D. MMMM YYYY [kl.] hh:mm:ss A', // Norwegian Bokmål
  'ne': 'D MMMM YYYY, Aको h:mm:ss A बजे', // Nepalese
  'nl': 'D MMMM YYYY hh:mm:ss A', // Dutch
  'nn': 'D. MMMM YYYY [kl.] h:mm:ss A', // Nynorsk
  'pl': 'D MMMM YYYY hh:mm:ss A', // Polish
  'pt': 'D [de] MMMM [de] YYYY hh:mm:ss A', // Portuguese
  'ro': 'D MMMM YYYY h:mm:ss A', // Romanian
  'ru': 'D MMMM YYYY г., hh:mm:ss A', // Russian
  'sd': 'D MMMM YYYY hh:mm:ss A', // Sindhi
  'se': 'MMMM D. [b.] YYYY [ti.] hh:mm:ss A', // Northern Sami
  'si': 'YYYY MMMM D, a h:mm:ss', // Sinhalese
  'sk': 'D. MMMM YYYY h:mm:ss A', // Slovak
  'sl': 'D. MMMM YYYY h:mm:ss A', // Slovenian
  'sq': 'D MMMM YYYY hh:mm:ss A', // Albanian
  'sr': 'D. MMMM YYYY h:mm:ss A', // Serbian
  'ss': 'D MMMM YYYY h:mm:ss A', // siSwati
  'sv': 'D MMMM YYYY [kl.] hh:mm:ss A', // Swedish
  'sw': 'D MMMM YYYY hh:mm:ss A', // Swahili
  'ta': 'D MMMM YYYY, hh:mm:ss A', // Tamil
  'te': 'D MMMM YYYY, A h:mm:ss', // Telugu
  'tet': 'D MMMM YYYY hh:mm:ss A', // Tetun Dili (East Timor)
  'th': 'D MMMM YYYY เวลา h:mm:ss A', // Thai
  'tlh': 'D MMMM YYYY hh:mm:ss A', // Klingon (Really ??)
  'tr': 'D MMMM YYYY hh:mm:ss A', // Turkish
  'tzl': 'D. MMMM [dallas] YYYY hh.mm.ss', // Talossan
  'tzm': 'D MMMM YYYY hh:mm:ss A', // Central Atlas Tamazight
  'uk': 'D MMMM YYYY р., hh:mm:ss A', // Ukrainian
  'ur': 'D MMMM YYYY hh:mm:ss A', // Urdu
  'uz': 'D MMMM YYYY hh:mm:ss A', // Uzbek
  'vi': 'D MMMM [năm] YYYY hh:mm:ss A', // Vietnamese
  'yo': 'D MMMM YYYY h:mm:ss A', // Yoruba Nigeria
  'zh': 'YYYY年MMMD日Ah点mm分ss' // Chinese (China)
};
